import { of } from "rxjs";
import { combineEpics } from "redux-observable";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models/IAsyncWrapper";
import { produceLoadLoadingLoadedEpic } from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { updateAnalysisActionTypes, updatingAnalysis, updatedAnalysis, editPanelViewChange } from "./AnalysisEdit.ducks.js";
import { loadV2StudyAbstractsForStepId, loadV2StudyAbstract } from "../../ducks/AnalysisStudyListActions.js";
import AnalysisResourceV2 from "@ane/exp-data/lib/resources/expapiv2/Analysis.resource";
const updateAnalysisStudyEpic = produceLoadLoadingLoadedEpic({
  filterOnType: updateAnalysisActionTypes.LOAD,
  loadResource: (payload) => {
    var _a, _b, _c, _d;
    const studyId = (_b = (_a = payload == null ? void 0 : payload.analysisEditRequest) == null ? void 0 : _a.StudyId) != null ? _b : 0;
    const workspaceId = ((_c = payload == null ? void 0 : payload.analysisEditRequest) == null ? void 0 : _c.WorkspaceId) || "";
    const studyName = ((_d = payload == null ? void 0 : payload.analysisEditRequest) == null ? void 0 : _d.AnalysisStudyDescription) || "";
    return AnalysisResourceV2.updateAnalysis(workspaceId, studyId, { name: studyName });
  },
  loadingAction: (payload) => updatingAnalysis(),
  loadedAction: (successData, payload, error) => {
    var _a, _b, _c, _d, _e, _f;
    const actions = [updatedAnalysis(getCompletedAsyncWrapperObj("Created", error || ""))];
    if (!error) {
      const stepId = (_b = (_a = payload == null ? void 0 : payload.analysisEditRequest) == null ? void 0 : _a.ExpStepId) != null ? _b : "";
      const studyId = (_d = (_c = payload == null ? void 0 : payload.analysisEditRequest) == null ? void 0 : _c.StudyId) != null ? _d : 0;
      const workspaceId = (_f = (_e = payload == null ? void 0 : payload.analysisEditRequest) == null ? void 0 : _e.WorkspaceId) != null ? _f : "";
      payload.onDone && payload.onDone();
      actions.push(editPanelViewChange(stepId, studyId, false));
      actions.push(loadV2StudyAbstractsForStepId({ workspaceId, stepId, invalidateCache: true }));
      actions.push(loadV2StudyAbstract({ workspaceId, stepId, studyId, invalidateCache: true }));
    }
    return of(...actions);
  }
});
const analysisEditEpics = combineEpics(updateAnalysisStudyEpic);
export {
  analysisEditEpics as default,
  updateAnalysisStudyEpic
};
//# sourceMappingURL=AnalysisEdit.epics.js.map
